import type { Department, GetInitializeSummaryResponse } from '@bliks-io/contracts';
import { parseDepartmentPath } from '@/pages/organization/organigram/utils/buildOrganigramLayout';

export type OverviewStatKey =
  | 'departments'
  | 'members'
  | 'positions'
  | 'functions'
  | 'teams'
  | 'systems'
  | 'processes';

export interface OverviewStat {
  key: OverviewStatKey;
  count: number;
}

/** Ordered stat entries for the overview step's tiles; keys map to i18n labels at the render site. */
export function buildOverviewStats(summary: GetInitializeSummaryResponse): OverviewStat[] {
  return [
    { key: 'departments', count: summary.departments.count },
    { key: 'members', count: summary.members.count },
    { key: 'positions', count: summary.positions.count },
    { key: 'functions', count: summary.functions.count },
    { key: 'teams', count: summary.teams.count },
    { key: 'systems', count: summary.systems.count },
    { key: 'processes', count: summary.processes.count }
  ];
}

/**
 * Depth of the department tree: the maximum number of '#'-separated segments
 * in any materialized `path`, or 0 for an empty list.
 */
export function computeDepartmentLevels(departments: Department[]): number {
  return departments.reduce(
    (maxLevel, department) => Math.max(maxLevel, parseDepartmentPath(department.path).level),
    0
  );
}
